<template>
	<v-modal class="v-modal--switch-to-phone">
		<template v-slot:header>
			<h1 class="alpha">Complete ID Checks</h1>
		</template>
		<div>
			<div class="section--buddy section--proof-of-funds">
				<div class="editorial">
					<p v-if="blockingTask" class="beta">Before you can complete your ID checks, you will need to <span
						v-html="$present('lower', blockingTask.descriptions.auto)"/>.</p>
					<p v-else class="beta">The following people still need to complete their ID check&hellip;</p>
				</div>
			</div>
			<table v-if="!blockingTask">
				<thead>
					<tr>
						<th align="left">Client</th>
						<th align="right" class="actions">
							<span>Actions</span>
						</th>
					</tr>
					<tr v-for="(client, clientIndex) in clientGroup.clients" :key="clientIndex">
						<td v-html="$present('fullName', client)"/>
						<td v-if="client.idCheck.status === 'pending'" align="right">
							—
						</td>
						<td v-else align="right">
							<button
								v-if="client.id === $authed().id"
								class="button button--small--primary"
								@click.prevent="showCompleteIdCheckModal()">Complete Your ID Check
							</button>
							<button
								v-else
								class="button button--small--primary"
								@click.prevent>Send A Reminder
							</button>
						</td>
					</tr>
				</thead>
			</table>
		</div>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						class="button button--text"
						@click.prevent="$vmodal.close()">{{ blockingTask ? "Not Now" : "Close" }}
					</button>
				</li>
				<li v-if="blockingTask">
					<button
						class="button button--primary"
						v-html="blockingTask.tasks.auto"
						@click.prevent="triggerTask(blockingTask)"/>
				</li>
				<li v-else-if="nextSteppedTask">
					<button
						class="button button--primary"
						@click.prevent="showNextTaskModal()">Next Task
					</button>
				</li>
				<li v-else-if="remainingTasks">
					<button
						class="button button--primary"
						@click.prevent="showRemainingTasksModal()">Remaining Tasks
					</button>
				</li>
				<!--				<li v-if="$can('complete', $authed().idCheck)">-->
				<!--					<button-->
				<!--						class="button button&#45;&#45;primary"-->
				<!--						@click.prevent="showCompleteIdCheckModal()">Complete Your ID Check-->
				<!--					</button>-->
				<!--				</li>-->
			</ul>
		</template>
	</v-modal>
</template>
<script>
import {mapGetters} from "vuex";
import essentialTasks from "../mixins/essentialTasks";
import opensCompleteIdCheckModal from "../mixins/opensCompleteIdCheckModal";

export default {
	components: {},

	mixins: [
		essentialTasks,
		opensCompleteIdCheckModal,
	],

	computed: {
		...mapGetters([
			"essentialTasks",
			"steppedTasks",
			"nextTask",
			"nextTaskAfter",
			"remainingTasks",
		]),
		blockingTasks() {
			return _.filter(this.steppedTasks(), task => {
				return ["confirmPersonalDetails", "payOutstandingInvoice"].indexOf(task.key) > -1;
			});
		},
		blockingTask() {
			return _.find(this.blockingTasks, task => {
				return !task.complete;
			});
		},
		nextSteppedTask() {
			return _.first(_.filter(this.steppedTasks(), task => {
				return task.key !== "completeIdCheck";
			}));
		},
	},

	methods: {
		continueOnDesktop() {
			window.open(this.$authed().idCheck.link);
		},
	},
};
</script>
